import { Route, Switch, Redirect } from 'react-router-dom'
import { PaymentResponsePage, PaymentFailedPage, GuestAutoLogin, OptInSignupPage, OptOutSignupPage, MarketplaceSignupPage, MenuItems, Documents, Information, DownloadsPage, ChangePasswordPage, Privacy } from 'ui'
import { HomeFeed, CommunityCalendar, Events, SeatedEventReservationBlock, PrivacyPolicy } from 'ui/events'
import { Parks, Clubs, Retails } from 'ui/parks'
import { Calendar, PlacesCalender, AdminPlacesCalender, GuestSecretCalender, GuestEmbedCalendar } from 'ui/calendar'
import { Group } from 'ui/groups'
import { PaymentCardList, PaymentCardEditor } from 'ui/payment-settings'
import { PeopleList, MessageDashboard } from 'ui/people'
import { VideoChat } from 'ui/video-chat'
import { TouchScreen } from 'ui/touch-screen'
import { Qrcode} from 'ui'

export function Routes() {
  return (
    <Switch>
      <Redirect from='/'                  exact to='/home'/>
      <Route path="/home"                 exact component={HomeFeed} />
      <Route path="/home/:id"             exact component={HomeFeed} />
      <Route path="/community"            exact component={CommunityCalendar} />
      <Route path="/community/:id"              component={CommunityCalendar} />
      <Route path="/large-screen/:id"   exact component={GuestSecretCalender} />
      <Route path="/touch-screen/:id"   exact component={TouchScreen} />
      <Route path="/embed-calendar" exact component={GuestEmbedCalendar} />
      <Route path="/embed-calendar/:id" exact component={GuestEmbedCalendar} />
      <Route path="/community-calendar"   exact component={Calendar} />
      <Route path="/community-calendar/:id" exact component={Calendar} />
      <Route path="/places-calendar"   exact component={PlacesCalender} />
      <Route path="/places-calendar/:id" exact component={PlacesCalender} />
      <Route path="/admin-places-calendar"   exact component={AdminPlacesCalender} />
      <Route path="/admin-places-calendar/:id" exact component={AdminPlacesCalender} />
      <Route path="/groups/:id" exact component={Group} />
      <Route path="/groups"     exact component={Group} />
      <Route path="/parks"                exact component={Parks} />
      <Route path="/parks/:id"            exact component={Parks} />
      <Route path="/parks/:id/:eventId"         component={Parks} />
      <Route path="/clubs"                exact component={Clubs} />
      <Route path="/clubs/:id"            exact component={Clubs} />
      <Route path="/clubs/:id/:eventId"         component={Clubs} />
      <Route path="/retails"              exact component={Retails} />
      <Route path="/retails/:id"          exact component={Retails} />
      <Route path="/retails/:id/:eventId"       component={Retails} />
      <Route path="/events/:listId"       exact component={Events} />
      <Route path="/events/:listId/:id"         component={Events} />
      <Route path="/settings/privacy"     exact component={Privacy} />
      <Route path="/settings/payment"     exact component={PaymentCardList} />
      <Route path="/settings/payments/:reservationId/:amountArg/:dateId/:timeId/:serviceId/:ticketTypes"       component={PaymentCardEditor} />
      <Route path="/settings/payments/:reservationId/:amountArg/:ticketTypes"       component={PaymentCardEditor} />
      <Route path="/settings/payments/:reservationId"       component={PaymentCardEditor} />
      <Route path="/settings/payments/:smartButtonId/:amount"       component={PaymentCardEditor} />
      <Route path="/settings/payment/new"       component={PaymentCardEditor} />
      <Route path="/settings/documents"         component={Documents} />
      <Route path="/settings"                   component={Information} />
      <Route path="/menu/:menuId"         exact component={MenuItems} />
      <Route path="/menu/:menuId/:id"     exact component={MenuItems} />
      <Route path="/menu/:menuId/:id/:subId"    component={MenuItems} />
      <Route path="/people"               exact component={PeopleList} />
      <Route path="/people/club/:club_id" exact component={PeopleList} />
      <Route path="/people/event/:reserved_event_id" exact component={PeopleList} />
      <Route path="/people/place_checkins/:place_checkins" exact component={PeopleList} />
      <Route path="/people/place_checkins/:place_checkins/:id" exact component={PeopleList} />
      <Route path="/people/event/:reserved_event_id/:id" exact component={PeopleList} />
      <Route path="/people/club/:club_id/:id" exact component={PeopleList} />
      <Route path="/people/:id"                 component={PeopleList} />
      <Route path="/people:::args"        exact component={PeopleList} />
      <Route path="/people:::args/:id"          component={PeopleList} />
      <Route path="/video-chat"           exact component={VideoChat} />
      <Redirect from="/settings"                to="/settings/payment" />
      <Route path="/privacypolicy"  component={PrivacyPolicy} />
      <Route path="/sms-opt-in"        exact component={OptInSignupPage} />
      <Route path="/sms-opt-out"        exact component={OptOutSignupPage} />
      <Route path="/change-password"      exact component={ChangePasswordPage} />
      <Route path="/app-downloads"        exact component={DownloadsPage} />
      <Route path="/marketplace-signup"   exact component={MarketplaceSignupPage} />
      <Route path="/sms-service-dashboard"   exact component={MessageDashboard} />
      <Route path="/payment/success" exact component={PaymentResponsePage} />
      <Route path="/payment/failed" exact component={PaymentFailedPage} />
      <Route path="/event/:id/confirm/:token"   exact component={SeatedEventReservationBlock} />
      <Route path="/event/:id/reserve/:token/seats::seats/spots::spots"   exact component={SeatedEventReservationBlock} />
      <Route path="/event/:id/cancel/:token/event::event"   exact component={SeatedEventReservationBlock} />
    </Switch>
  )
}

export function UnauthenticatedRoutes() {
  return <Switch>
    <Route path="/sms-opt-in"        exact component={OptInSignupPage} />
    <Route path="/sms-opt-out"        exact component={OptOutSignupPage} />
    <Route path="/sms-service-dashboard"   exact component={MessageDashboard} />
    <Route path="/login"  component={GuestAutoLogin} />
    <Route path="/large-screen/:id"   exact component={GuestSecretCalender} />
    <Route path="/touch-screen/:id" exact component={TouchScreen} />
    <Route path="/embed-calendar" exact component={GuestEmbedCalendar} />
    <Route path="/embed-calendar/:id" exact component={GuestEmbedCalendar} />
    <Route path="/marketplace-signup" component={MarketplaceSignupPage} />
    <Route path="/payment/success" component={PaymentResponsePage} />
    <Route path="/payment/failed" component={PaymentFailedPage} />
    <Route path="/app-downloads" component={DownloadsPage} />
    <Route path="/settings/payments/:reservationId/:amountArg"       component={PaymentCardEditor} />
    <Route path="/settings/payments/:reservationId"       component={PaymentCardEditor} />
    <Route path="/settings/payments/:smartButtonId/:amount"       component={PaymentCardEditor} />
    <Route path="/event/:id/confirm/:token"   exact component={SeatedEventReservationBlock} />
    <Route path="/event/:id/reserve/:token/seats::seats/spots::spots"   exact component={SeatedEventReservationBlock} />
    <Route path="/event/:id/cancel/:token/event::event"   exact component={SeatedEventReservationBlock} />
    <Redirect to="/login" />
    <Route path="/privacypolicy"  component={PrivacyPolicy} />
  </Switch>
}
